import { render, staticRenderFns } from "./InquiryDetails.vue?vue&type=template&id=c968f848&"
import script from "./InquiryDetails.vue?vue&type=script&lang=js&"
export * from "./InquiryDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports